import { Card, CardBody, Col, Row } from 'reactstrap'
import { BasicProgressBars } from '../../../../Utils/Constants'
import { basicProgressData, basicProgressList } from '../../../../Data/Ui-Kits/Progress/Progress'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'
import { ProgressBar } from '../../../../AbstractElements'

const BasicProgressBarsCart = () => {
  return (
    <Card>
      <CardHeaderCommon title={BasicProgressBars} span={basicProgressData} />
      <CardBody className="progress-showcase">
        <Row>
          <Col>
            <ProgressBar value="0" />
            {basicProgressList.map(({ color, value, text }, index) => (
              <ProgressBar color={color} value={value} key={index}>
                {text && text}
              </ProgressBar>
            ))}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default BasicProgressBarsCart